module.exports = __webpack_public_path__ + "static/media/kubik.a218a0b3.gif";